module.exports = __webpack_public_path__ + "static/assets/983a4dd6c8389a1ef6811eb022bf780e.png";